(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Converter"]) return;
  try {
    
document.getElementById('divide').addEventListener('click', function() {
  const saltGrams = parseFloat(document.getElementById('firstNumber').value);
  const sodiumMg = parseFloat(document.getElementById('secondNumber').value);

  // If only salt (g) is entered, convert to sodium (mg)
  if (!isNaN(saltGrams) && isNaN(sodiumMg)) {
    // Convert grams → mg first
    const sodium = (saltGrams * 1000 * 0.393).toFixed(2);
    document.getElementById('secondNumber').value = sodium;
  } 
  // If only sodium (mg) is entered, convert to salt (g)
  else if (isNaN(saltGrams) && !isNaN(sodiumMg)) {
    // Convert mg sodium → mg salt → grams
    const salt = ((sodiumMg * 2.54) / 1000).toFixed(2);
    document.getElementById('firstNumber').value = salt;
  } 
  // If both or neither are entered
  else {
    alert('Please enter a value in only one field.');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
